import { styled } from '@zoopla-eng/zds-components/themes';
import { Button } from '@zoopla-eng/zds-components/button';

export const ButtonWithWidth = styled(Button, {
    width: '48px'
});
